import {PortfolioAccountContext} from '#/components/portfolio/context/portfolio-account-context';
import {PortfolioProfile} from '#/components/portfolio/sections/portfolio-profile';
import {PortfolioRewardsTile} from '#/components/portfolio/sections/portfolio-rewards';
import {PortfolioValue} from '#/components/portfolio/sections/portfolio-value';
import {PortfolioIconTitle} from '#/components/portfolio/subcomponents/portfolio-icon-title';
import {ClassName} from '#/utils/utils';
import {UserIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, useContext} from 'react';
import {useTranslation} from 'react-i18next';

export const PortfolioInfo: FunctionComponent<ClassName> = ({className}) => {
  const {isCurrentUser} = useContext(PortfolioAccountContext);
  const {t} = useTranslation('translation');

  return (
    <>
      <div className='@4xl/portfolio:sticky @4xl/portfolio:top-0 @4xl/portfolio:left-0 @4xl/portfolio:bg-grayblue z-20 flex items-center gap-2 pt-4 sm:pt-8 pb-7'>
        <PortfolioIconTitle IconComponent={UserIcon}>{t('pages.portfolio.sections.info.title')}</PortfolioIconTitle>
      </div>

      <div className='grid grid-cols-1 auto-rows-min grid-flow-row gap-4 pb-4 sm:pb-0 sm:@4xl/portfolio:pb-10 @xl/portfolio-info:gap-4 @xl/portfolio-info:grid-cols-2 @xl/portfolio-info:grid-flow-dense'>
        <PortfolioProfile
          className={`@xl/portfolio-info:col-start-1 @xl/portfolio-info:col-span-1 @xl/portfolio-info:row-start-1 @xl/portfolio-info:row-span-1 ${
            isCurrentUser ? '' : '@xl/portfolio-info:col-span-2'
          }`}
        />
        <PortfolioValue
          className={`@xl/portfolio-info:col-start-1 @xl/portfolio-info:col-span-2 @xl/portfolio-info:row-start-2 @xl/portfolio-info:row-span-1 ${
            isCurrentUser ? '@xl/user-profile:row-span-2' : ''
          }`}
        />
        {isCurrentUser && <PortfolioRewardsTile className='' />}
      </div>
    </>
  );
};
